import "jquery-form";
import "jquery-validation";
import "../validator-rules";
import ssoAjax from "../tools/sso.ajax";
import ssoTool from "../tools/sso.tool";
import ssoAlert from "../tools/sso.alert";
import Swal from "sweetalert2";

function buildRegisterMailSentModalConfig(redirectUrl) {
    return {
        imageUrl: '/icon/modal/email.svg',
        imageAlt: language.register_mail_send,
        title: language.register_mail_send,
        html: `
            <p class="register-mail-sent-modal__description">
                ${language.one_more_step}<br>
                ${language.register_mail_verify}
            </p>
            <div class="register-mail-sent-modal__notice">
                <img src="/icon/modal/clock.svg" alt="" class="register-mail-sent-modal__notice-icon">
                <span>${language.register_mail_expire_notice}</span>
            </div>
        `,
        footer: `<a href="${redirectUrl}" class="btn btn-primary text-white w-100">${globalLanguage.ok}</a>`,
        customClass: {
            popup: 'register-mail-sent-modal',
            image: 'register-mail-sent-modal__image',
            title: 'register-mail-sent-modal__title',
            htmlContainer: 'register-mail-sent-modal__content',
            footer: 'register-mail-sent-modal__footer',
        },
    };
}

function showAppleEmailBlockedPopup() {
    const tpl = document.getElementById('apple_email_blocked_popup_tpl');

    Swal.fire({
        showConfirmButton: false,
        showClass: { popup: '' },
        autofocus: false,
        customClass: {
            popup: 'sso-alert-apple-blocked-popup',
            htmlContainer: 'sso-alert-apple-blocked-html',
        },
        html: tpl ? tpl.innerHTML : '',
        didRender: function () {
            $(Swal.getHtmlContainer()).find('#btn_apple_email_blocked_confirm').on('click', function () {
                Swal.close();
                window.location.href = window.appleBlockedLoginUrl;
                return false;
            });
        },
    });
}

export function init() {
    if (window.socialRegisterStatus === 'failed') {
        const reason = window.socialRegisterError;
        if (reason === 'anonymous_email_is_not_allow') {
            showAppleEmailBlockedPopup();
        } else {
            ssoAlert.error(language?.register?.error?.[reason] || reason);
        }
    }

    const registerForm = $('#register_form');
    const btnSubmit = $('#btn_submit');
    const termsModal = new bootstrap.Modal('#terms_modal');
    const termsContent = $('#terms_content');
    const btnAgreeTerms = $('#btn_agree_terms');
    const agreementCheckbox = $('#agreement');
    const debounceTimers = {};
    const lastValues = {};

    ssoTool.setInputEyeSwitch('#password');
    ssoTool.setInputEyeSwitch('#password_confirm');
    ssoTool.setInputClearSwitch(['#last_name', '#first_name', '#account']);

    $('#btn_social_register_apple').on('click', function (e) {
        e.preventDefault();

        const redirectUrl = $(this).attr('href');
        const warning = language?.register?.social_apple_warning;

        ssoAlert.confirm(
            warning?.title,
            warning?.html,
            function () {
                window.location.href = redirectUrl;
            },
            {
                imageUrl: '/icon/modal/apple-warning.svg',
                customClass: { popup: 'sso-alert-confirm-popup sso-alert-apple-warning-popup' }
            }
        );

        return false;
    });

    // Open terms modal
    $('.link-terms').on('click', function(e) {
        e.preventDefault();
        termsModal.show();
        termsContent.scrollTop(0);
        btnAgreeTerms.prop('disabled', true);
    });

    // Enable agree button only when scrolled to bottom
    termsContent.on('scroll', function() {
        const scrollTop = $(this).scrollTop();
        const scrollHeight = $(this)[0].scrollHeight;
        const clientHeight = $(this)[0].clientHeight;

        if (scrollTop + clientHeight >= scrollHeight - 5) {
            btnAgreeTerms.prop('disabled', false);
        }
    });

    // When agreed, enable and check the agreement checkbox
    btnAgreeTerms.on('click', function() {
        agreementCheckbox.removeClass('disabled').prop('checked', true);
        agreementCheckbox.trigger('change');
        registerForm.validate().element(agreementCheckbox);
        termsModal.hide();
    });

    registerForm.validate({
        onkeyup: function(element) {
            if (element.name === 'account') {
                const val = $(element).val();
                if (lastValues.account === val) {
                    return; // skip if unchanged
                }
                lastValues.account = val;
                clearTimeout(debounceTimers.account);
                debounceTimers.account = setTimeout(() => {
                    this.element(element);
                }, 500);
                return;
            }

            // default behavior for other fields
            this.element(element);
        },
        onfocusout: function(element) {
            if (element.name === 'account') {
                return; // avoid extra account checks on blur
            }
            this.element(element);
        },
        showErrors: function() {
            const hasErrors = this.numberOfInvalids() > 0;
            btnSubmit.prop('disabled', hasErrors);
            btnSubmit.toggleClass('disabled', hasErrors);

            this.defaultShowErrors();
        },
        errorElement: 'span',
        errorPlacement: function(error, element) {
            element.closest('.col').find('div.error-message').html(error);
        },
        submitHandler: function(form) {
            ssoAjax.submit(form, function(response) {
                try {
                    if (response.status === false) {
                        throw new Error(response.message);
                    }

                    const redirectUrl = $('#redirect_url').val() || '/';

                    ssoAlert.fire(buildRegisterMailSentModalConfig(redirectUrl));

                    $(form).resetForm();
                } catch (e) {
                    ssoAlert.error(e.message);
                }

                ssoAjax.btnSetToSubmit();
            })
        }
    });
}
